import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CoreModule } from "./core/core.module";
import { MemberModule } from "./member/member.module";
import { OffersModule } from "./offers/offers.module";
import { OfferRedemptionsModule } from "./offer-redemptions/offer-redemptions.module";
import { AdminUsersModule } from "./admin-users/admin-users.module";
import { OfferTypesModule } from "./offer-types/offer-types.module";
import { MembershipCodeModule } from "./membership-code/membership-code.module";
import { PagesModule } from "./pages/pages.module";
import { WhitelistedDomainsModule } from "./whitelisted-domains/whitelisted-domains.module";
import { NotificationsModule } from "./notifications/notifications.module";
import { LocationsModule } from "./locations/locations.module";
import { DashboardModule } from "./dashboard/dashboard.module";
import { ReportsModule } from "./reports/reports.module";
import { AuthModule } from "./auth/auth.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";
import { routing } from "./app.routing";
import { FormsModule } from "@angular/forms";
import { SponsorsModule } from "./sponsors/sponsors.module";
import { AppVersionsModule } from "./app-versions/app-versions.module";
import { QuarterliesModule } from "./quarterlies/quarterlies.module";
import { SubscriptionPlansModule } from "./subscription-plans/subscription-plans.module";
import { CancelSubscriptionModule } from "./cancel-subscription/cancel-subscription.module";
import { CouponsModule } from "./coupons/coupons.module";
import { TagsModule } from "./tags/tags.module";
import { JobCategoriesModule } from "./job-categories/job-categories.module";
import { EmailsModule } from "./emails/emails.module";
import { AbTestsModule } from "./ab-tests/ab-tests.module";
import { ExitSurveyModule } from "./exit-survey/exit-survey.module";
import { ReferralsModule } from "./referrals/referrals.module";

@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    MemberModule,
    OffersModule,
    OfferRedemptionsModule,
    AdminUsersModule,
    OfferTypesModule,
    MembershipCodeModule,
    PagesModule,
    WhitelistedDomainsModule,
    SponsorsModule,
    NotificationsModule,
    LocationsModule,
    DashboardModule,
    ReportsModule,
    AuthModule,
    QuarterliesModule,
    routing,
    AppVersionsModule,
    SubscriptionPlansModule,
    CancelSubscriptionModule,
    CouponsModule,
    TagsModule,
    JobCategoriesModule,
    EmailsModule,
    AbTestsModule,
    ExitSurveyModule,
    ReferralsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/app.module.ts